<template>
  <div id="notes-slider"
    v-if="!disabled && value.length > 0"
    class="carousel slide"
    data-wrap="false"
    data-ride="false"
  >
    <div class="carousel-inner">
      <div v-for="(note, index) in value" class="carousel-item" :key="index" v-bind:class="[index == 0 ? 'active' : '']">
        <d-row>
          <d-col md="2" class="text-left"></d-col>
          <d-col md="8" class="text-center">
            <b-card
               no-body
               class="custom-card"
               border-variant="secondary"
               :header="note.CreatedDate | date"
               header-border-variant="secondary"
               align="center"
             >
               <b-card-text><small>{{note.Description}}</small></b-card-text>
            </b-card>
          </d-col>
          <d-col md="2" class="text-right"></d-col>
        </d-row>
      </div>
    </div>

    <div v-if="value.length > 1" id="carousel-controls">
      <a class="carousel-control-prev" href="#notes-slider" role="button" data-slide="prev">
        <span class="carousel-control-prev-icon" aria-hidden="true"></span>
        <span class="sr-only">Previous</span>
      </a>
      <a class="carousel-control-next" href="#notes-slider" role="button" data-slide="next">
        <span class="carousel-control-next-icon" aria-hidden="true"></span>
        <span class="sr-only">Next</span>
      </a>
    </div>

  </div>
</template>

<script>
export default {
  name: 'notes-slider',
  props: {
    "value": {
      type: Array,
      default: []
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  model: {},
  methods: {
    GoToSlide(slideIndex) {
      $('#notes-slider.carousel').carousel(slideIndex);
    }
  },
  computed: {}
};
</script>
<style scoped>
#notes-slider {
    box-shadow: none;
}
.custom-card {
  margin-top: 30px;
  margin-bottom: 30px;
}
.carousel-control-prev-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23AAA' viewBox='0 0 8 8'%3E%3Cpath d='M5.25 0l-4 4 4 4 1.5-1.5-2.5-2.5 2.5-2.5-1.5-1.5z'/%3E%3C/svg%3E");
}
.carousel-control-next-icon {
    background-image: url("data:image/svg+xml;charset=utf8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23AAA' viewBox='0 0 8 8'%3E%3Cpath d='M2.75 0l-1.5 1.5 2.5 2.5-2.5 2.5 1.5 1.5 4-4-4-4z'/%3E%3C/svg%3E");
}
</style>



// WEBPACK FOOTER //
// src/components/common/notes-slider.vue